import styled, { css } from 'styled-components';

export const Item = styled.div`
  border: 1px solid #e6e8f0;
  border-radius: 4px;

  & + & {
    margin-top: 8px;
  }
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  cursor: pointer;
`;

export const Chevron = styled.div`
  height: 20px;
`;

export const ItemBody = styled.div`
  padding: 16px 16px 12px 16px;
`;

export const Field = styled.div`
  & + & {
    margin-top: 24px;
  }
`;

export const FieldHead = styled.div`
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const FieldName = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;

export const FieldNameText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #696f8c;
`;

export const FieldPinned = styled.div`
  height: 20px;
  margin-left: 9px;
`;

interface IFieldContent {
  empty?: boolean;
}

export const FieldContent = styled.div<IFieldContent>`
  font-size: 14px;
  font-weight: 400;
  color: #474d66;

  ${({ empty }) =>
    empty &&
    css`
      color: #c1c4d6;
      opacity: 1;
      font-style: italic;
    `}
`;

export const DataLink = styled.a`
  color: #1371fe;
  font-size: 14px;
  font-weight: 500;
`;

export const ProductSpecBody = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
`;
